import * as React from 'react';
const OsteoporosiIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="m126.18 61.81-15.65 15.65c-1.83 1.83-4.49 2.5-7 1.86-3.11-.79-6.56.13-8.86 2.76-2.91 3.33-2.89 8.38.05 11.68 2.3 2.59 5.73 3.48 8.81 2.7-.76 3 .06 6.32 2.49 8.61 3.42 3.24 8.86 3.21 12.24-.07a8.83 8.83 0 0 0 2.48-8.26c-.54-2.44.18-5 1.95-6.77l15.83-15.83M73.82 138.19l15.65-15.65c1.83-1.83 4.49-2.5 7-1.86 3.11.79 6.56-.13 8.86-2.76a8.84 8.84 0 0 0 2.12-4.87 9.98 9.98 0 0 1-6.59-2.75c-.06-.06-.13-.12-.19-.19a10.14 10.14 0 0 1-2.94-7.83c-3.09.21-6.13-1-8.24-3.37a10.07 10.07 0 0 1-2.54-6.34A8.77 8.77 0 0 0 81.74 95a8.83 8.83 0 0 0-2.48 8.26c.54 2.44-.18 5-1.95 6.77l-15.83 15.83"
      className="prefix__cls-2"
    />
    <path
      d="M101.53 87.84c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M126.76 71.3c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M112.97 88.84c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M71.55 131.08c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M76.33 120.84c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M87.73 116.78c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M87.56 107.65c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M120.93 82.69c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M112.97 99.32c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11"
      className="prefix__cls-1"
    />
  </svg>
);
export default OsteoporosiIcon;
